import { call, put } from "redux-saga/effects";
import { Actions } from "../../constants/actionTypes";
import { getStore } from "../../../Utils/storeUtils";
import { apiRequest } from "../../../Utils/axiosApi";

export function* fetchUpcomingInvoice(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/license/upcomingSubscriptions?orgId=${action.orgId}&country=${action.country}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_UPCOMING_INVOICE, data: result.data });
      action?.meta?.onSuccess(result.data);
    } else {
      yield put({ type: Actions.SET_UPCOMING_INVOICE, data: null });
    }
  } catch (err) {
    // Toast("Technical error", "Failed to fetch the Plans", "danger");
    // return { isApiSuccessful: false, data: err };
  }
}
export function* fetchInvoiceHistory(action) {
  try {
    // Use yield inside the generator function
    const result = yield call(apiRequest, {
      url: `/cashfree/fetchAllCashFreeInvoices?orgId=${action.orgId}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_INVOICE_HISTORY, data: result.data });
      action?.meta?.onSuccess(result.data);
    } else {
      yield put({ type: Actions.SET_INVOICE_HISTORY, data: null });
    }
  } catch (err) {
    // Handle error
    console.error("Failed to fetch invoice history", err);
    action?.meta?.onFailure(err);
  }
}

export function* getStripeInvoiceApi(action) {
  try {
    // Use yield inside the generator function
    const result = yield call(apiRequest, {
      url: `/stripe/getInvoices?orgId=${action.orgId}`,
      method: "POST",
    });

    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_STRIPE_INVOICE, data: result.data });
      action?.meta?.onSuccess(result.data);
    } else {
      yield put({ type: Actions.SET_STRIPE_INVOICE, data: null });
    }
  } catch (err) {
    // Handle error
    console.error("Failed to fetch invoice history", err);
    action?.meta?.onFailure(err);
  }
}

export function* getStripeUpcomingInvoiceApi(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/stripe/upcomingInvoice`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_STRIPE_UPCOMING_INVOICE,
        data: result.data,
      });
      action?.meta?.onSuccess(result.data);
    } else {
      yield put({ type: Actions.SET_STRIPE_UPCOMING_INVOICE, data: null });
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* getTimeperiodDetailApi(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/dashboard/timePeriodGraphData?type=${action.data.type}&orgId=${action.data.orgId}&startDate=${action.data.startDate}&endDate=${action.data.endDate}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_TIMELINEGRAPH_DETAILS,
        data: result.data,
      });

      return result;
    } else {
      action?.meta?.onError();

      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action?.meta?.onError();
    console.log("Technical Iss", "Please try again later", "danger");
  }
}

export function* getUserCardsSagaApi(action) {
  try {
    const url = `/stripe/getCards?orgId=${action.data.orgId}`;

    const result = yield call(apiRequest, {
      url: url,
      method: "POST",

      data: {},
    });

    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      yield put({ type: Actions.SET_USER_CARDS, data: result.data });
      return result;
    } else {
      action.meta.onError();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* getCashfreeCreateSubscriptionApi(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/cashfree/createSubscription`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);

      return result;
    } else {
      action.meta?.onError();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* getCashfreeUpdateSubscriptionApi(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/cashfree/updateSubscription?newPlanName=${action.data.newPlanName}&orgId=${action.data?.orgId}`,
      method: "PUT",
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);

      return result;
    } else {
      action.meta?.onError();

      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    return { isApiSuccessful: false, data: err };
  }
}

export function* getStripeCreateSubscriptionApi(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/stripe/createPLSub`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* getStripeUpdateAddonSubscriptionApi(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/stripe/updateSubscriptionsWithAddOns`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* getStripeUpdateSubscriptionApi(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/stripe/updateSubscription?priceId=${action.data?.priceId}&orgId=${action.data?.orgId}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiStripePublishableKey(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/stripe/initiatePayment`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);

      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetCashfreeDiscount(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/cashfree/getCouponDiscount?priceId=${action.data?.priceId}&couponCode=${action.data?.couponCode}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      yield put({ type: Actions.SET_CASHFREE_DISCOUNT, data: result.data });
      return result;
    } else {
      action.meta.onError();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetCashfreeAddons(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/cashfree/createAddonSubscription`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetFetchStatus(action) {
  try {
    const { orgId, basePlan, addon } = action.data;
    const result = yield call(apiRequest, {
      url: `/cashfree/fetchStatus?orgId=${orgId}&basePlan=${basePlan}&addon=${addon}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);
      yield put({
        type: Actions.SET_FETCH_STATUS,
        data: result.data,
      });
      return result;
    } else {
      action.meta?.onError();

      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();

    return { isApiSuccessful: false, data: err };
  }
}

export function* apiCreateStagingAddonStripe(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/stripe/StagingAddonPLStripe?quantity=${action.data.quantity}&orgId=${action.data.orgId}&priceId=${action.data.priceId}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

// One-time storage add-on for EBS sites: quantity = packs per site, siteIds = comma-separated sites to grow
export function* apiCreateStorageAddonStripe(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/stripe/StorageAddonPLStripe?quantity=${action.data.quantity}&orgId=${action.data.orgId}&priceId=${action.data.priceId}&siteIds=${action.data.siteIds}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiCreateStorageAddonCashfree(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/cashfree/StorageAddonPLCF?quantity=${action.data.quantity}&orgId=${action.data.orgId}&siteIds=${action.data.siteIds}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

// One-time performance upgrade for one EBS site: quantity is always 1, siteId = the site to resize
export function* apiCreatePerformanceUpgradeStripe(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/stripe/PerformanceAddonPLStripe?orgId=${action.data.orgId}&priceId=${action.data.priceId}&siteId=${action.data.siteId}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiCreatePerformanceUpgradeCashfree(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/cashfree/PerformanceAddonPLCF?orgId=${action.data.orgId}&siteId=${action.data.siteId}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiCreateStagingAddonCashfree(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/cashfree/StagingAddonPLCF?quantity=${action.data.quantity}&orgId=${action.data.orgId}&priceId=${action.data.priceId}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError();
      console.log("Technical Error ", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    console.log("Technical Error", "Please try again later", "danger");
    return { isApiSuccessful: false, data: err };
  }
}
